import { render, staticRenderFns } from "./RentsReportFilter.vue?vue&type=template&id=680b54b8&"
import script from "./RentsReportFilter.vue?vue&type=script&lang=js&"
export * from "./RentsReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports